import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../../App.css";
import { apiPostAuth, apiPostFileAuth } from "../../utils/api";
import toast from "react-hot-toast";

export default function MemberDetailPage() {
  const { member_id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState(null);
  const [loanList, setLoanList] = useState([]);

  const [profilePicture, setProfilePicture] = useState(null);
  const [governmentId, setGovernmentId] = useState(null);

  const [profilePictureModal, setProfilePictureModal] = useState(false);
  const [governmentIdModal, setGovernmentIdModal] = useState(false);

  const [imageModal, setImageModal] = useState({
    show: false,
    title: "",
    imageUrl: "",
  });

  const [confirmModal, setConfirmModal] = useState({
    show: false,
    action: null,
  });

  const [editModal, setEditModal] = useState(false);
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [editForm, setEditForm] = useState({
    full_name: "",
    full_address: "",
    phone_number: "",
  });

  useEffect(() => {
    fetchMemberDetail();
  }, [member_id]);

  const fetchMemberDetail = async () => {
    try {
      const response = await apiPostAuth("member/get_member_detail.php", {
        member_id,
      });

      if (response.result === 1) {
        setMember(response.member_data);
        setLoanList(response.member_data.loan_list || []);

        setEditForm({
          full_name: response.member_data.full_name || "",
          full_address: response.member_data.full_address || "",
          phone_number: response.member_data.phone_number || "",
        });
      } else {
        navigate("/dashboard/member");
      }
    } catch (error) {
      navigate("/dashboard/member");
    } finally {
      setLoading(false);
    }
  };

  const formatRegisteredDate = (dateString) => {
    if (!dateString || dateString.length < 14) return "-";

    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    const hour = dateString.slice(8, 10);
    const minute = dateString.slice(10, 12);
    const second = dateString.slice(12, 14);

    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);

    return date.toLocaleString("id-ID", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatCurrency = (value) => {
    const amount = Number(value || 0);

    return amount.toLocaleString("id-ID", {
      style: "currency",
      currency: "IDR",
      maximumFractionDigits: 0,
    });
  };

  const openImageModal = (title, imageUrl) => {
    setImageModal({
      show: true,
      title,
      imageUrl,
    });
  };

  const confirmToggleMember = () => {
    setPassword("");
    setErrorMessage("");
    setConfirmModal({
      show: true,
      action: member?.is_active === 1 ? "disable" : "enable",
    });
  };

  const handleUpdateMember = async () => {
    setErrorMessage("");

    if (!editForm.full_name.trim()) {
      setErrorMessage("Full name is required.");
      return;
    }

    if (!editForm.full_address.trim()) {
      setErrorMessage("Address is required.");
      return;
    }

    if (!editForm.phone_number.trim()) {
      setErrorMessage("Phone number is required.");
      return;
    }

    try {
      const response = await apiPostAuth("member/update_member.php", {
        member_id,
        full_name: editForm.full_name,
        full_address: editForm.full_address,
        phone_number: editForm.phone_number,
      });

      if (response.result === 1) {
        setEditModal(false);
        fetchMemberDetail();
        toast.success("Informasi Member telah diperbarui.");
      } else {
        setErrorMessage(response.message || "Failed to update member.");
      }
    } catch (error) {
      setErrorMessage("Oops, something went wrong. Please try again.");
    }
  };

  const handleUpdateProfilePicture = async () => {
  setErrorMessage("");

  if (!profilePicture) {
    setErrorMessage("Mohon pilih Foto Profil.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("profile_picture", await convertImageToJpeg(profilePicture));
    formData.append("member_id", member_id);

    const response = await apiPostFileAuth(
      "member/update_profile_picture.php",
      formData
    );

    if (response.result === 1) {
      setProfilePictureModal(false);
      setProfilePicture(null);
      fetchMemberDetail();
      toast.success("Foto Profil telah diperbarui.");
    } else {
      setErrorMessage(response.message || "Gagal mengubah foto profil.");
    }
  } catch (error) {
    setErrorMessage("Oops, something went wrong. Please try again.");
  }
};

const handleUpdateGovernmentId = async () => {
  setErrorMessage("");

  if (!governmentId) {
    setErrorMessage("Mohon pilih Foto KTP.");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("government_id", await convertImageToJpeg(governmentId));
    formData.append("member_id", member_id);

    const response = await apiPostFileAuth(
      "member/update_government_id.php",
      formData
    );

    if (response.result === 1) {
      setGovernmentIdModal(false);
      setGovernmentId(null);
      fetchMemberDetail();
      toast.success("Foto KTP telah diperbarui.");
    } else {
      setErrorMessage(response.message || "Gagal mengubah Foto KTP.");
    }
  } catch (error) {
    setErrorMessage("Oops, something went wrong. Please try again.");
  }
};

const convertImageToJpeg = (
    file,
    maxWidth = 2000,
    quality = 0.7
    ) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (event) => {
        const img = new Image();

        img.src = event.target.result;

        img.onload = () => {
            let width = img.width;
            let height = img.height;

            // Resize large images
            if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
            }

            const canvas = document.createElement("canvas");

            canvas.width = width;
            canvas.height = height;

            const ctx = canvas.getContext("2d");

            // White background (important for PNG/HEIC transparency)
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(0, 0, width, height);

            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
            (blob) => {
                if (!blob) {
                reject(new Error("JPEG conversion failed"));
                return;
                }

                // Generate .jpg filename
                const fileName =
                file.name.replace(/\.[^/.]+$/, "") + ".jpg";

                const jpegFile = new File(
                [blob],
                fileName,
                {
                    type: "image/jpeg",
                    lastModified: Date.now(),
                }
                );

                resolve(jpegFile);
            },
            "image/jpeg",
            quality
            );
        };

        img.onerror = reject;
        };

        reader.onerror = reject;
    });
    };

  const handleCreateLoan = () => {
    navigate(`/dashboard/loan/create/${member_id}`);
  };

  const handleOpenLoanDetail = (loanId) => {
    navigate(`/dashboard/loan/${loanId}`);
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <div className="loading-spinner"></div>
        <p>Memuat detail member...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={() => navigate(-1)}
        style={backButtonStyle}
      >
        ← Kembali
      </button>

      <section style={heroSectionStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
          <img
            src={member?.profile_picture_compressed}
            alt={member?.full_name}
            style={profileImageStyle}
          />

          <div>
            <h1 style={{ fontSize: "1.8rem", color: "#1f2937", margin: 0 }}>
              {member?.full_name}
            </h1>

            <p style={{ margin: "6px 0 0 0", color: "#6b7280" }}>
              ID Member: {member?.member_id}
            </p>

            <div
              style={{
                ...statusBadgeStyle,
                backgroundColor: member?.is_active === 1 ? "#dcfce7" : "#fee2e2",
                color: member?.is_active === 1 ? "#166534" : "#991b1b",
              }}
            >
              {member?.is_active === 1 ? "Aktif" : "Tidak Aktif"}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <button onClick={handleCreateLoan} className="primary-button">
            Buat Pinjaman
          </button>

          <button
            onClick={() => {
              setErrorMessage("");
              setEditModal(true);
            }}
            className="secondary-button"
          >
            Ubah Data Member
          </button>
        </div>
      </section>

      <section style={sectionStyle}>
        <h2 style={sectionTitleStyle}>Informasi Member</h2>

        <div style={infoGridStyle}>
          <div style={infoCardStyle}>
            <p style={infoLabelStyle}>Nama Lengkap</p>
            <p style={infoValueStyle}>{member?.full_name}</p>
          </div>

          <div style={infoCardStyle}>
            <p style={infoLabelStyle}>Nomor HP / Whatsapp</p>
            <p style={infoValueStyle}>{member?.phone_number}</p>
          </div>

          <div style={infoCardStyle}>
            <p style={infoLabelStyle}>Alamat Lengkap</p>
            <p style={infoValueStyle}>{member?.full_address}</p>
          </div>

          <div style={infoCardStyle}>
            <p style={infoLabelStyle}>Status</p>
            <p
              style={{
                ...infoValueStyle,
                color: member?.is_active === 1 ? "#16a34a" : "#dc2626",
              }}
            >
              {member?.is_active === 1 ? "Aktif" : "Tidak Aktif"}
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "18px", flexWrap: "wrap" }}>
            <button
                onClick={() => openImageModal("Foto Profil", member?.profile_picture)}
                className="secondary-button"
            >
                Liat Foto Profil
            </button>

            <button
                onClick={() => {
                    setErrorMessage("");
                    setProfilePicture(null);
                    setProfilePictureModal(true);
                }}
                className="primary-button"
                >
                Ubah Foto Profil
                </button>
        </div>
        <div style={{ display: "flex", gap: "10px", marginTop: "18px", flexWrap: "wrap" }}>
            

            <button
                onClick={() => openImageModal("Foto KTP", member?.government_id)}
                className="secondary-button"
            >
                Lihat Foto KTP
            </button>


            <button
            onClick={() => {
                setErrorMessage("");
                setGovernmentId(null);
                setGovernmentIdModal(true);
            }}
            className="primary-button"
            >
                Ubah Foto KTP
            </button>
        </div>
      </section>

      <section style={sectionStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <h2 style={{ ...sectionTitleStyle, marginBottom: 0 }}>Daftar Pinjaman</h2>

          <button onClick={handleCreateLoan} className="primary-button">
            Buat Pinjaman
          </button>
        </div>

        {loanList.length === 0 ? (
          <div style={emptyBoxStyle}>
            <p style={{ margin: 0, color: "#6b7280" }}>
              Belum ada pinjaman dari member ini.
            </p>
          </div>
        ) : (
          <div style={{ display: "grid", gap: "12px" }}>
            {loanList.map((loan) => (
              <div key={loan.loan_id} style={loanCardStyle}>
                <div>
                  <h3
                    style={{
                      fontSize: "1.1rem",
                      margin: "0 0 6px 0",
                      color: "#1f2937",
                    }}
                  >
                    {formatCurrency(loan.loan_amount)}
                  </h3>

                  <p style={loanMetaStyle}>
                    Bunga: {loan.interest_rate}%
                  </p>

                  <p style={loanMetaStyle}>
                    Durasi Pinjaman: {loan.payment_term} Bulan
                  </p>

                  <p style={loanMetaStyle}>
                    Tanggal Pinjaman: {formatRegisteredDate(loan.loan_time_stamp)}
                  </p>

                  <p
                    style={{
                      fontSize: "0.85rem",
                      margin: "6px 0 0 0",
                      color: loan.is_active === 1 ? "#16a34a" : "#969696",
                      fontWeight: "600",
                    }}
                  >
                    {loan.is_active === 1 ? "Pinjaman Aktif" : "Selesai"}
                  </p>
                </div>

                <button
                  onClick={() => handleOpenLoanDetail(loan.loan_id)}
                  className="primary-button"
                  style={{ padding: "8px 16px", minWidth: "120px" }}
                >
                  Detail Pinjaman
                </button>
              </div>
            ))}
          </div>
        )}
      </section>

      {imageModal.show && (
        <div style={modalOverlayStyle}>
          <div style={imageModalContentStyle}>
            <h3 style={{ marginTop: 0, color: "#1f2937" }}>{imageModal.title}</h3>

            <img
              src={imageModal.imageUrl}
              alt={imageModal.title}
              style={{
                width: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
                borderRadius: "8px",
                border: "1px solid #e5e7eb",
              }}
            />

            <button
              onClick={() => setImageModal({ show: false, title: "", imageUrl: "" })}
              className="secondary-button"
              style={{ marginTop: "15px", width: "120px" }}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {editModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0 }}>Edit Member Info</h3>

            {errorMessage && <p style={errorTextStyle}>{errorMessage}</p>}

            <input
              type="text"
              placeholder="Full Name"
              value={editForm.full_name}
              onChange={(e) =>
                setEditForm({ ...editForm, full_name: e.target.value })
              }
              style={inputStyle}
            />

            <textarea
              placeholder="Full Address"
              value={editForm.full_address}
              onChange={(e) =>
                setEditForm({ ...editForm, full_address: e.target.value })
              }
              rows={4}
              style={{ ...inputStyle, resize: "vertical" }}
            />

            <input
              type="text"
              placeholder="Phone Number"
              value={editForm.phone_number}
              onChange={(e) =>
                setEditForm({ ...editForm, phone_number: e.target.value })
              }
              style={inputStyle}
            />

            <div style={{ marginTop: "18px" }}>
              <button
                onClick={handleUpdateMember}
                className="primary-button"
                style={{ marginRight: "10px", width: "100px" }}
              >
                Simpan
              </button>

              <button
                onClick={() => {
                  setEditModal(false);
                  setErrorMessage("");
                }}
                className="secondary-button"
                style={{ width: "100px" }}
              >
                Batal
              </button>
            </div>
          </div>
        </div>
      )}

      <>
      {profilePictureModal && (
        <div style={modalOverlayStyle}>
            <div style={modalContentStyle}>
            <h3 style={{ marginTop: 0 }}>Ubah Foto Profil</h3>

            {errorMessage && <p style={errorTextStyle}>{errorMessage}</p>}

            <div style={fileBoxStyle}>
                <div style={fileIconStyle}>📷</div>

                <div style={{ flex: 1 }}>
                <p style={fileTitleStyle}>Foto Profil</p>
                <p style={fileNameStyle}>
                    {profilePicture ? profilePicture.name : "Belum Dipilih"}
                </p>
                </div>

                <label htmlFor="edit_profile_picture" style={fileButtonStyle}>
                Pilih Foto Profil
                </label>

                <input
                id="edit_profile_picture"
                type="file"
                accept="image/*"
                onChange={(e) => setProfilePicture(e.target.files[0])}
                style={{ display: "none" }}
                />
            </div>

            <div style={{ marginTop: "18px" }}>
                <button
                onClick={handleUpdateProfilePicture}
                className="primary-button"
                style={{ marginRight: "10px", width: "100px" }}
                >
                Simpan
                </button>

                <button
                onClick={() => {
                    setProfilePictureModal(false);
                    setProfilePicture(null);
                    setErrorMessage("");
                }}
                className="secondary-button"
                style={{ width: "100px" }}
                >
                Batal
                </button>
            </div>
            </div>
        </div>
        )}
        {governmentIdModal && (
            <div style={modalOverlayStyle}>
                <div style={modalContentStyle}>
                <h3 style={{ marginTop: 0 }}>Ubah Foto KTP</h3>

                {errorMessage && <p style={errorTextStyle}>{errorMessage}</p>}

                <div style={fileBoxStyle}>
                    <div style={fileIconStyle}>📷</div>

                    <div style={{ flex: 1 }}>
                    <p style={fileTitleStyle}>Foto KTP</p>
                    <p style={fileNameStyle}>
                        {governmentId ? governmentId.name : "Belum Dipilih"}
                    </p>
                    </div>

                    <label htmlFor="edit_government_id" style={fileButtonStyle}>
                    Pilih Foto KTP
                    </label>

                    <input
                    id="edit_government_id"
                    type="file"
                    accept="image/*"
                    onChange={(e) => setGovernmentId(e.target.files[0])}
                    style={{ display: "none" }}
                    />
                </div>

                <div style={{ marginTop: "18px" }}>
                    <button
                    onClick={handleUpdateGovernmentId}
                    className="primary-button"
                    style={{ marginRight: "10px", width: "100px" }}
                    >
                    Simpan
                    </button>

                    <button
                    onClick={() => {
                        setGovernmentIdModal(false);
                        setGovernmentId(null);
                        setErrorMessage("");
                    }}
                    className="secondary-button"
                    style={{ width: "100px" }}
                    >
                    Batal
                    </button>
                </div>
                </div>
            </div>
            )}
      </>
    </div>
  );
}

/* Styles */

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
};

const heroSectionStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  marginBottom: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "18px",
  flexWrap: "wrap",
};

const profileImageStyle = {
  width: "82px",
  height: "82px",
  borderRadius: "50%",
  objectFit: "cover",
  border: "3px solid #e5e7eb",
};

const statusBadgeStyle = {
  display: "inline-block",
  padding: "6px 10px",
  borderRadius: "999px",
  fontSize: "0.8rem",
  fontWeight: "600",
  marginTop: "10px",
};

const sectionStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  marginBottom: "20px",
};

const sectionTitleStyle = {
  fontSize: "1.2rem",
  marginBottom: "15px",
  color: "#1f2937",
};

const infoGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "15px",
};

const infoCardStyle = {
  backgroundColor: "#f9fafb",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #e5e7eb",
};

const infoLabelStyle = {
  fontSize: "0.85rem",
  color: "#6b7280",
  margin: "0 0 6px 0",
};

const infoValueStyle = {
  fontSize: "1rem",
  fontWeight: "600",
  color: "#1f2937",
  margin: 0,
};

const loanCardStyle = {
  backgroundColor: "#f9fafb",
  border: "1px solid #e5e7eb",
  borderRadius: "10px",
  padding: "15px 18px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "15px",
  flexWrap: "wrap",
};

const loanMetaStyle = {
  fontSize: "0.9rem",
  color: "#6b7280",
  margin: "4px 0",
};

const emptyBoxStyle = {
  padding: "20px",
  borderRadius: "10px",
  backgroundColor: "#f9fafb",
  border: "1px dashed #d1d5db",
  textAlign: "center",
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  padding: "20px",
};

const modalContentStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
  width: "360px",
  maxWidth: "95%",
};

const imageModalContentStyle = {
  backgroundColor: "#fff",
  padding: "22px",
  borderRadius: "12px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
  width: "650px",
  maxWidth: "95%",
  textAlign: "center",
};

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "10px",
  marginTop: "10px",
  border: "1px solid #d1d5db",
  borderRadius: "8px",
  fontSize: "0.95rem",
};

const errorTextStyle = {
  color: "#dc2626",
  fontSize: "0.9rem",
  marginBottom: "10px",
};

const fileBoxStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "16px",
  border: "1px solid #e5e7eb",
  borderRadius: "12px",
  backgroundColor: "#f9fafb",
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginTop: "12px",
};

const fileIconStyle = {
  width: "44px",
  height: "44px",
  borderRadius: "10px",
  backgroundColor: "#eef2ff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "1.3rem",
  flexShrink: 0,
};

const fileTitleStyle = {
  margin: 0,
  fontWeight: "600",
  color: "#1f2937",
  marginBottom: "4px",
};

const fileNameStyle = {
  margin: 0,
  fontSize: "0.85rem",
  color: "#6b7280",
  wordBreak: "break-word",
};

const fileButtonStyle = {
  padding: "9px 13px",
  backgroundColor: "#111827",
  color: "#fff",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "0.85rem",
  fontWeight: "500",
  whiteSpace: "nowrap",
};